import * as tslib_1 from "tslib";
import { memoize, Component, htmlToElement, removeElement, htmlEscape, renderDateCell, findElements, createFormatter, computeFallbackHeaderFormat } from '@fullcalendar/core';
import { buildResourceTextFunc } from '../common/resource-rendering';
import ResourceApi from '../api/ResourceApi';
var ResourceDayHeader = /** @class */ (function (_super) {
    tslib_1.__extends(ResourceDayHeader, _super);
    function ResourceDayHeader(parentEl) {
        var _this = _super.call(this) || this;
        _this.processOptions = memoize(_this._processOptions);
        _this.parentEl = parentEl;
        return _this;
    }
    ResourceDayHeader.prototype._processOptions = function (options, calendar) {
        this.datesAboveResources = options.datesAboveResources;
        this.resourceTextFunc = buildResourceTextFunc(options.resourceText, calendar);
    };
    ResourceDayHeader.prototype.render = function (props, context) {
        var options = context.options, calendar = context.calendar, theme = context.theme;
        this.processOptions(options, calendar);
        this.parentEl.innerHTML = ''; // because might be nbsp
        this.parentEl.appendChild(this.el = htmlToElement('<div class="fc-row ' + theme.getClass('headerRow') + '">' +
            '<table class="' + theme.getClass('tableGrid') + '">' +
            '<thead></thead>' +
            '</table>' +
            '</div>'));
        this.thead = this.el.querySelector('thead');
        var html;
        this.dateFormat = createFormatter(options.columnHeaderFormat ||
            computeFallbackHeaderFormat(props.datesRepDistinctDays, props.dates.length));
        if (props.dates.length === 1) {
            html = this.renderResourceRow(props.resources);
        }
        else {
            if (this.datesAboveResources) {
                html = this.renderDayAndResourceRows(props.dates, props.resources);
            }
            else {
                html = this.renderResourceAndDayRows(props.resources, props.dates);
            }
        }
        this.thead.innerHTML = html;
        this.processResourceEls(props.resources);
    };
    ResourceDayHeader.prototype.destroy = function () {
        removeElement(this.el);
    };
    ResourceDayHeader.prototype.renderResourceRow = function (resources) {
        var _this = this;
        var cellHtmls = resources.map(function (resource) {
            return _this.renderResourceCell(resource, 1);
        });
        return this.buildTr(cellHtmls);
    };
    ResourceDayHeader.prototype.renderDayAndResourceRows = function (dates, resources) {
        var dateHtmls = [];
        var resourceHtmls = [];
        for (var _i = 0, dates_1 = dates; _i < dates_1.length; _i++) {
            var date = dates_1[_i];
            dateHtmls.push(this.renderDateCell(date, resources.length));
            for (var _a = 0, resources_1 = resources; _a < resources_1.length; _a++) {
                var resource = resources_1[_a];
                resourceHtmls.push(this.renderResourceCell(resource, 1, date));
            }
        }
        return this.buildTr(dateHtmls) +
            this.buildTr(resourceHtmls);
    };
    ResourceDayHeader.prototype.renderResourceAndDayRows = function (resources, dates) {
        var resourceHtmls = [];
        var dateHtmls = [];
        for (var _i = 0, resources_2 = resources; _i < resources_2.length; _i++) {
            var resource = resources_2[_i];
            resourceHtmls.push(this.renderResourceCell(resource, dates.length));
            for (var _a = 0, dates_2 = dates; _a < dates_2.length; _a++) {
                var date = dates_2[_a];
                dateHtmls.push(this.renderDateCell(date, 1, resource));
            }
        }
        return this.buildTr(resourceHtmls) +
            this.buildTr(dateHtmls);
    };
    // Cell Rendering Utils
    // ----------------------------------------------------------------------------------------------
    // a cell with the resource name. might be associated with a specific day
    ResourceDayHeader.prototype.renderResourceCell = function (resource, colspan, date) {
        var dateEnv = this.context.dateEnv;
        return '<th class="fc-resource-cell"' +
            ' data-resource-id="' + resource.id + '"' +
            (date ?
                ' data-date="' + dateEnv.formatIso(date, { omitTime: true }) + '"' :
                '') +
            (colspan > 1 ?
                ' colspan="' + colspan + '"' :
                '') +
            '>' +
            htmlEscape(this.resourceTextFunc(resource)) +
            '</th>';
    };
    // a cell with date text. might have a resource associated with it
    ResourceDayHeader.prototype.renderDateCell = function (date, colspan, resource) {
        var props = this.props;
        return renderDateCell(date, props.dateProfile, props.datesRepDistinctDays, props.dates.length * props.resources.length, this.dateFormat, this.context, colspan, resource ? 'data-resource-id="' + resource.id + '"' : '');
    };
    ResourceDayHeader.prototype.buildTr = function (cellHtmls) {
        if (!cellHtmls.length) {
            cellHtmls = ['<td>&nbsp;</td>'];
        }
        if (this.props.renderIntroHtml) {
            cellHtmls = [this.props.renderIntroHtml()].concat(cellHtmls);
        }
        if (this.context.isRtl) {
            cellHtmls.reverse();
        }
        return '<tr>' +
            cellHtmls.join('') +
            '</tr>';
    };
    // Post-rendering
    // ----------------------------------------------------------------------------------------------
    // given a container with already rendered resource cells
    ResourceDayHeader.prototype.processResourceEls = function (resources) {
        var _a = this.context, calendar = _a.calendar, isRtl = _a.isRtl, view = _a.view;
        findElements(this.thead, '.fc-resource-cell').forEach(function (node, col) {
            col = col % resources.length;
            if (isRtl) {
                col = resources.length - 1 - col;
            }
            var resource = resources[col];
            calendar.publiclyTrigger('resourceRender', [
                {
                    resource: new ResourceApi(calendar, resource),
                    el: node,
                    view: view
                }
            ]);
        });
    };
    return ResourceDayHeader;
}(Component));
export default ResourceDayHeader;
